import { Box, Chip, CircularProgress, Grid, Skeleton, Slide, Typography, } from '@mui/material';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Button from '@mui/material/Button';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector, } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { alertMsg, kFormatter } from '../../../utils/basicUtils';
import ReviewStep from './ReviewStep'
import SelectServiceStep from './SelectServiceStep';
import SelectEditsStep from './SelectEditsStep';
import { jobActions } from '../../../redux/reducers/job-slice';
import UploadImageStep from './UploadImageStep';
// import useAxios from '../../../hooks/use-axios';
import useAxiosPrivate from '../../../hooks/use-axios-private';
// import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
// import LocalMallIcon from '@mui/icons-material/LocalMall';
// import PaymentModal from '../../subscriptions/PaymentModal';
import useAuth from '../../../hooks/use-auth';
import { authActions } from '../../../redux/reducers/auth-slice';
import Popup from '../../../components/Popup';
import { useTheme } from '@emotion/react';
import { APP_CURRENCY } from '../../../constants';
import PayModal from '../../subscriptions/PayModal';
import ModalBox from '../../../components/ModalBox';
import { Form, Formik } from 'formik';
import StrictNumberField from '../../../components/StrictNumberField';
import * as Yup from 'yup';
import { TextField } from 'formik-mui';

const steps = ['Choose Service', 'Upload Files', 'Select Edits', 'Review'];
const PRICE_RANGE = [100, 200, 500, 1000, 2000]

const CartValue = () => {
    const cartValue = useSelector(state => state.job.cart_value)
    return (
        <Box sx={{ position: "absolute", right: 0, top: 0 }}>
            {/* <Box sx={{ textAlign: "right", position: "relative" }}>
                <Box>
                    <ShoppingCartIcon sx={{ fontSize: "34px" }} color="action" />
                </Box>
                <Box sx={{ position: "absolute", top: "-24px", right: "-10px" }}>
                    <Typography sx={{ fontSize: "11px", fontWeight: 500, color: "#fff", background: "#3f51b5", width: "34px", height: "34px", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center" }}>${kFormatter(cartValue)}</Typography>
                </Box>
            </Box> */}
            <Box>
                <Typography className="ribbon-pop">{APP_CURRENCY.currency_symbol} {kFormatter(cartValue)}</Typography>
            </Box>
        </Box >
    )
}

export default function JobStepper({ draftId }) {
    const theme = useTheme()
    const { user } = useAuth()
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const [slideDirection, setSlideDirection] = useState('left')
    const [activeStep, setActiveStep] = useState(0);
    const [enableNext, setEnableNext] = useState(0);
    // const [skipped, setSkipped] = useState(new Set());
    const axios = useAxiosPrivate()
    const job = useSelector(state => state.job)
    const [isShowPaymentModal, setIsShowPaymentModal] = useState(false)
    const [enableBack, setEnableBack] = useState(false)
    const [nextLoader, setNextLoader] = useState(false)
    const [paymentConfirmModel, setPaymentConfirmModel] = useState(false)
    const [credits, setCredits] = useState(false)
    const [paymentAmount, setPaymentAmount] = useState(0)

    const paymentValidation = Yup.object({
        amount: Yup.number()
            .required('Amount is required')
            .min(1, 'Amount should be greater than or equal to 1')
            .max((user.wallet?.wallet_limit - user.wallet?.wallet_amount) || 0, `Amount should not exceed ${(user.wallet?.wallet_limit - user.wallet?.wallet_amount) || 0}`),
    })

    const prepareJobFromDraft = useCallback((draft) => {
        let draftData = structuredClone(draft)
        delete draft["id"]
        draft['draft_id'] = draftId
        draft['service_lst'] = draftData.service_lst.map(service => service.id)
        draft['service'] = [draftData.service_lst[0]]
        draft['preferences_lst'] = []
        draft['preferences_obj'] = []
        if (draftData.preferences_lst) {
            for (let preference of draftData.preferences_lst) {
                draft['preferences_lst'].push(preference.id)
                preference.cost = preference.price
                delete preference.price
                draft['preferences_obj'].push(preference)
            }
        }
        draft['base_preferences_lst'] = []
        draft['base_preferences_obj'] = []
        if (draftData.base_preferences_lst) {
            for (let preference of draftData.base_preferences_lst) {
                draft['base_preferences_lst'].push(preference.id)
                draft['base_preferences_obj'].push(preference)
            }
        }
        return draft
    }, [])

    const loadDraft = useCallback(
        async () => {
            try {
                const resp = await axios.get(`/jobs/drafts/${draftId}`)
                let draftData = resp.data.data.job_draft
                dispatch(jobActions.updateJob(prepareJobFromDraft(draftData)))
            }
            catch (err) {
                console.error("🚀 ~ file: Createjob.jsx:26 ~ useEffect ~ err:", err)
            }
        },
        [],
    )

    const saveJobToDraft = useCallback(async (job, showAlert = false) => {
        try {
            const isDraft = !job.draft_id
            const resp = isDraft ? await axios.post(`jobs/drafts/`, job) : await axios.put(`jobs/drafts/${job.draft_id}`, job);
            console.log(resp)

            if (isDraft) {
                const draftId = resp.data.data.job_draft.id
                dispatch(jobActions.updateDraftId(draftId))
                dispatch(jobActions.updateJobId(resp.data.data.job_draft.job_id))
                dispatch(jobActions.updateMediaPath(resp.data.data.job_draft.media_path))
            }
            showAlert && alertMsg(resp.data.message, 'success')
        }
        catch (err) {
            console.error("🚀 ~ file: JobStepper.jsx:65 ~ saveJobToDraft ~ err:", err)
        }

    }, [axios, dispatch])

    const getAvailableCredits = async () => {
        try {
            const response = await axios.get("users/wallet/")
            dispatch(authActions.updateWallet(response.data.data.wallet))
        }
        catch (error) {
            console.error(error)
        }
    }
    useEffect(() => {
        const preventClose = (e) => {
            e.preventDefault();
            return (e.returnValue = "");
        }
        window.addEventListener("beforeunload", preventClose);
        dispatch(jobActions.resetJob())
        return () => {
            window.removeEventListener("beforeunload", preventClose)
        }
    }, [])

    useEffect(() => {
        dispatch(jobActions.updateUserId(user.id))
    }, [dispatch, user])

    const submitJob = async () => {
        try {
            const resp = await axios.post('/jobs/', {
                "draft_id": job.draft_id,
                "turn_around_time_id": job.turn_around_time,
                "coupon_code": job.coupon_code,
                "items": job.summary.items,
                "user_id": job.user_id
            })
            dispatch(authActions.updateWallet(resp.data.data.wallet))
            dispatch(jobActions.resetJob())
            alertMsg(resp.data.message, "success")
            navigate('/jobs')
        }
        catch (err) {
            console.error(err)
            if (err.response.data.message === "Insufficient funds. Sorry you don't have enough funds in wallet to process the transaction.") {
                setIsShowPaymentModal(true)
            }
        }
    }

    const handleNext = async () => {
        if (activeStep === steps.length - 1) {
            // submitJob()
            if (Number(user.wallet && user.wallet.wallet_amount) >= Number(job.summary && job.summary.net_price)) {
                setPaymentConfirmModel(true)
            }
            else {
                alertMsg("Insufficient funds. Sorry you don't have enough funds in wallet to process the transaction.", "warning")
                setIsShowPaymentModal(true)
            }
            return false
        }
        if (activeStep === 0) {
            if (!job.title) {
                alertMsg('Job title is required', 'warning')
                return false
            }
            if (job.service.length <= 0 && !job.service[0]) {
                alertMsg('Please choose a service', 'warning')
                return false
            }
            await saveJobToDraft(job)
        }
        if (activeStep > 0) {
            if (job.media.length < 1) {
                alertMsg('Media cannot be empty', 'error')
                return false
            }
            if (!job.output_file_count || job.output_file_count <= 0) {
                alertMsg('Invalid output file count', 'error')
                return false
            }
            if (job.output_file_count > job.media.length) {
                alertMsg(`Output file count should not exceed ${job.media.length}`, 'error')
                return false
            }
            saveJobToDraft(job)
        }
        setSlideDirection('left')
        // let newSkipped = skipped;

        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        // setSkipped(newSkipped);
    };

    const handleBack = () => {
        setSlideDirection('right')
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    useEffect(() => {
        draftId && loadDraft()
        return () => { dispatch(jobActions.resetJob()) }
    }, [dispatch])

    return (
        <Box sx={{ width: '100%', minHeight: { xs: "88vh", sm: "75vh", xl: "80vh" }, display: "flex", flexDirection: "column", justifyContent: "space-between", pb: 1, overflowY: "auto" }} className="scroll-none">
            <Box>
                <Stepper activeStep={activeStep} sx={{ mb: 3, mt: 2 }}>
                    {steps.map((label, index) => {
                        const stepProps = {};
                        const labelProps = {};
                        return (
                            <Step key={label} {...stepProps}>
                                <StepLabel {...labelProps}>
                                    <Typography sx={{ display: { xs: "none", md: "block", fontSize: "14px" } }}>{label}</Typography>
                                </StepLabel>
                            </Step>
                        );
                    })}
                </Stepper>
                <Box sx={{ position: "relative", mb: { xs: 6, sm: 0, xl: 6 }, display: activeStep === 0 || activeStep === 2 ? "block" : "none" }}>
                    <CartValue />
                </Box>
                <Box>
                    {activeStep === 0 &&
                        <Box sx={{ flexGrow: 1, pb: 2 }}>
                            <Slide direction={slideDirection} in={true} mountOnEnter unmountOnExit>
                                <Box>
                                    <SelectServiceStep
                                        enableNext={(action) => setEnableNext(action)}
                                    />
                                </Box>
                            </Slide>
                        </Box>
                    }
                    {activeStep === 1 &&
                        <Slide direction={slideDirection} in={true} mountOnEnter unmountOnExit>
                            <Box>
                                <UploadImageStep
                                    enableNext={(action) => setEnableNext(action)}
                                    enableBack={(action) => setEnableBack(action)}
                                    saveJobToDraft={saveJobToDraft}
                                />
                            </Box>
                        </Slide>
                    }

                    {activeStep === 2 &&
                        <Slide direction={slideDirection} in={true} mountOnEnter unmountOnExit>
                            <Box>
                                <SelectEditsStep enableNext={(action) => setEnableNext(action)} />
                            </Box>

                        </Slide>
                    }
                    {activeStep === 3 &&
                        <Slide direction={slideDirection} in={true} mountOnEnter unmountOnExit>
                            <Box>
                                <ReviewStep enableNext={(action) => setEnableNext(action)} saveJobToDraft={saveJobToDraft} />
                            </Box>
                        </Slide>
                    }
                </Box>
            </Box>


            <Box>
                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between", flexWrap: "wrap", pt: 2 }}>
                    <Box sx={{ pt: 2 }}>
                        <Button
                            disabled={activeStep === 0 || !enableBack}
                            onClick={handleBack}
                            sx={{ mr: 1 }}
                            variant="outlined"
                        >
                            Back
                        </Button>
                    </Box>
                    <Box sx={{ display: "flex", pt: 2 }}>
                        <Box>
                            {activeStep > 0 && job.media.length > 0 &&
                                <Button sx={{ fontSize: 13 }} onClick={() => saveJobToDraft(job, true)}
                                    variant="contained"
                                    // disabled={activeStep === 1 && !enableNext}
                                    disabled={!enableNext}
                                >
                                    Save as Draft
                                </Button>
                            }
                        </Box>
                        <Box sx={{ ml: 1 }}>
                            <Button
                                onClick={async (e) => {
                                    if (e.detail === 1) {
                                        setNextLoader(true)
                                        await handleNext()
                                        setNextLoader(false)
                                    }
                                }}
                                // onClick={handleNext}
                                disabled={!enableNext || nextLoader}
                                variant="contained"
                            >
                                {activeStep === steps.length - 1
                                    ? (user.wallet && user.wallet.wallet_amount < Number(job.summary && job.summary.net_price) ? 'Recharge & Finish' : 'Finish')
                                    : 'Next'}
                                {nextLoader && <CircularProgress sx={{ width: "22px !important", height: "22px !important", verticalAlign: "middle", ml: 1, color: "#fff" }} />}
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Box>

            {isShowPaymentModal &&
                <ModalBox open={true} onClose={() => setIsShowPaymentModal(false)}>
                    <Box sx={{ p: 2, pb: 1, }}>
                        <Box>
                            <Box>
                                <Typography sx={{ fontSize: { xs: 18, xl: 20 }, fontWeight: 500, color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}>
                                    Credits Available
                                </Typography>
                            </Box>
                            <Box>
                                {
                                    user.wallet.wallet_amount ?

                                        <Typography sx={{ fontSize: 36, mt: 5, textAlign: "center", color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}>
                                            {APP_CURRENCY.currency_symbol} {user.wallet.wallet_amount}
                                        </Typography>
                                        :
                                        <Box sx={{ width: "90px", mt: 5, mx: "auto" }}>
                                            <Skeleton sx={{ height: "56px" }} animation="wave" />
                                        </Box>
                                }
                            </Box>

                            {
                                user.wallet.wallet_limit ?
                                    <Box sx={{ textAlign: "center", pt: 2 }}>
                                        <Typography>Available top up limit upto ${user.wallet.wallet_limit}</Typography>
                                    </Box>
                                    :
                                    <Box sx={{ width: "240px", pt: 2, mx: "auto" }}>
                                        <Skeleton sx={{ height: "25px" }} animation="wave" />
                                    </Box>
                            }

                            <Box>
                                <Formik
                                    initialValues={{ amount: (Number(job.summary.net_price) - Number(user.wallet.wallet_amount)).toFixed(2) || 0 }}
                                    onSubmit={async (values, { setSubmitting, setFieldValue, resetForm }) => {
                                        try {
                                            setCredits(true)
                                            setPaymentAmount(values.amount)
                                        }
                                        catch (err) {
                                            console.error("🚀 ~ file: Subscription.jsx:367 ~ onSubmit={ ~ err:", err)
                                        }

                                    }}
                                    validationSchema={paymentValidation}
                                >
                                    {
                                        ({ setFieldValue, isSubmitting }) => (
                                            <Form>
                                                <Box sx={{ pt: 3 }}>
                                                    <Grid container spacing={{ xs: 3 }} sx={{ justifyContent: "center" }}>
                                                        {
                                                            PRICE_RANGE.map((price, index) => (
                                                                <Grid key={index} item onClick={() => {
                                                                    setFieldValue('amount', price)
                                                                }}>
                                                                    <Box>
                                                                        <Chip label={price} />
                                                                    </Box>
                                                                </Grid>
                                                            ))
                                                        }
                                                    </Grid>
                                                </Box>
                                                <Box>
                                                    <Box sx={{ pt: 4, textAlign: "center", pb: 3 }}>
                                                        <StrictNumberField name="amount" label="Enter Amount *" inputProps={{ min: 0, }} autoComplete='off' component={TextField} type="number" fullWidth />

                                                    </Box>
                                                    <Box sx={{ textAlign: "center", mt: 2 }}>
                                                        <Button type='submit' variant="outlined">Add {isSubmitting && <CircularProgress className="" sx={{ ml: 1, width: "16px !important", height: "16px !important", }} />}</Button>
                                                    </Box>
                                                </Box>
                                            </Form>
                                        )
                                    }
                                </Formik>
                            </Box>
                        </Box>
                    </Box>
                </ModalBox>
            }
            <Popup show={paymentConfirmModel} onSecondaryClick={() => setPaymentConfirmModel(false)} title={"Payment Confirmation"} consent={false} variant='primary'
                primaryBtnTxt={job.summary && (job.summary.net_price === 0 ? "Proceed" : "Pay")}
                onPrimaryClick={
                    async (e, loader) => {
                        if (e.detail === 1) {
                            loader(true)
                            try {
                                await submitJob()
                            }
                            catch (err) {
                                console.error("🚀 ~ file: JobStepper.jsx:351 ~ err:", err)
                            }
                            finally {
                                loader(false)
                            }
                        }
                    }
                }
            >


                <Box sx={{ mt: 2, textAlign: "center" }}>
                    {job.coupon_code ?
                        <Typography component='p' sx={{ fontSize: { xs: "16px", xl: "18px" }, fontWeight: "400", color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}>
                            <span style={{ fontWeight: "500" }}>{APP_CURRENCY.currency_symbol} {(job.summary.gross_price) - (job.summary.net_price)}</span> has been saved by using coupon <span style={{ fontWeight: "500" }}>"{job.coupon_code}"</span>.
                            <span style={{ fontWeight: "500", color: "red" }}> {job.summary && Number(job.summary.net_price) === 0 ? 'No amount' : (APP_CURRENCY.currency_symbol).concat(job.summary.net_price)}</span> will be deducted from your wallet amount <span style={{ fontWeight: "500" }}>{APP_CURRENCY.currency_symbol} {user.wallet && user.wallet.wallet_amount}</span> on payment
                        </Typography>
                        :
                        <Typography component='p' sx={{ fontSize: { xs: "16px", xl: "18px" }, fontWeight: "400", color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}>
                            You are about to pay<span style={{ fontWeight: "500", color: "red" }}> {APP_CURRENCY.currency_symbol} {job.summary && job.summary.net_price}</span> from your wallet amount <span style={{ fontWeight: "500" }}>{APP_CURRENCY.currency_symbol} {user.wallet && user.wallet.wallet_amount}</span>
                        </Typography>
                    }

                    <Typography component='p' sx={{ fontSize: { xs: "16px", xl: "18px" }, fontWeight: "400", color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}>
                        Do you want to proceed?</Typography>
                </Box>
            </Popup>

            {credits && <PayModal open={credits} paymentAmount={paymentAmount} onPaymentComplete={() => { setCredits(false); setIsShowPaymentModal(false); getAvailableCredits(); }} />}
        </Box >
    );
}